import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgPatternTriangles(props) {
	return (
		<SvgIcon {...props}>
			<path
				d="M3.6 3h17.449v18.049H3l9.324-9.325L3.6 3zm16.249 2.898L5.898 19.848h13.95V5.899z"
				fill="currentColor"
				fillRule="nonzero"
			/>
		</SvgIcon>
	)
}

export default SvgPatternTriangles
